import camsLogo from "@/assets/camsLogoLight.png";
import "./styles.css";
import Section from "./Section";
import Field from "./Field";
import useDownloadFile from "./useDownloadProfile";
import { Loader } from "@/components";
import { ACCOUNT_ID, ACH_ACCOUNT, ACH_ACCOUNT_NAME, ACH_BANK_NAME, ACH_ROUTING, ADDRESS_1, ADDRESS_2, ADS, ALTERNATE_LOGIN_ID, AUTO_BILLING_ENROLL, AUTO_BILLING_LA, AUTO_BILLING_LA_END_DATE, AUTO_BILLING_LA_START_DATE, AUTO_BILLING_START_DATE, CITY, CORRESPONDENCE_ADDRESS, DISPLAY_EMAIL, DISPLAY_LANDLINE, DISPLAY_MOBILE, DISPLAY_NAME, E_ACCOUNT_EMAIL, E_ACCOUNT_NAME, E_ACCOUNT_NO, E_ACCOUNT_PHONE, E_COM_SIGNUP, E_COM_START_DATE, EMAIL_ID_1, EMAIL_ID_2, FIRST_NAME, LANDLINE_NO, LAST_NAME, MOBILE_NO, OPT_EMERGENCY, OPT_GENERAL, PARTNER_EMAIL, PAYMENT_TYPE, PO_BOX, PROP_ADDRESS, SMS_PAST_DUE, STATE, USERNAME, ZELLE_URL, ZIPCODE } from "./consts";
import moment from "moment";

const DownloadProfile = () => {
  const {isUserDetailsLoading, isLoadingUserPreference, isOwnerAccountDtlDetailsLoading, form} = useDownloadFile();

  return (
    <>
      <div className="absolute top-0 left-0 bottom-0 right-0 bg-white h-[100vh]">
        <Loader containerClassName="bg-white" />
      </div>
      <div id="pdf-content" className="page-wrapper">
        <div className="header">
          <img src={camsLogo} alt="Company Logo" height="19px" />
        </div>

        {isUserDetailsLoading || isLoadingUserPreference || isOwnerAccountDtlDetailsLoading ? <></> : 
          <div className="container">
            <Section title="User Info">
              <div className="grid-4">
                <Field label="User ID" value={form.watch(USERNAME)} />
                <Field label="Alternate Login ID" value={form.watch(ALTERNATE_LOGIN_ID)} />
                <Field label="First Name" value={form.watch(FIRST_NAME)} />
                <Field label="Last Name" value={form.watch(LAST_NAME)} />
                <Field label="Mobile No." value={(form.watch(MOBILE_NO))} />
                <Field label="Landline No." value={form.watch(LANDLINE_NO)} />
                <Field label="Email ID 1" value={form.watch(EMAIL_ID_1)} />
                <Field label="Email ID 2" value={form.watch(EMAIL_ID_2)} />
              </div>
              <div className="sub-heading">Address</div>
              <div className="grid-3">
                <Field label="Street Address 1" value={form.watch(ADDRESS_1)} />
                <Field label="Street Address 2" value={form.watch(ADDRESS_2)} />
                <Field label="State" value={form.watch(STATE)} />
                <Field label="City" value={form.watch(CITY)} />
                <Field label="Zip Code" value={form.watch(ZIPCODE)} />
                <Field label="PO Box" value={form.watch(PO_BOX)} />
              </div>
              <div className="sub-heading">Correspondence Address</div>
              <div className="grid-3">
                <Field label="Street Address 1" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${ADDRESS_1}`)} />
                <Field label="Street Address 2" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${ADDRESS_2}`)} />
                <Field label="State" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${STATE}`)} />
                <Field label="City" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${CITY}`)} />
                <Field label="Zip Code" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${ZIPCODE}`)} />
                <Field label="PO Box" value={form.watch(`${CORRESPONDENCE_ADDRESS}.${PO_BOX}`)} />
              </div>
            </Section>
            <Section title="User Preference">
              <div className="grid-2">
                <Field label="SMS for Past Due" value={form.watch(SMS_PAST_DUE)} />
                <Field label="Opt In Emergency" value={form.watch(OPT_EMERGENCY)} />
                <Field label="Display Name" value={form.watch(DISPLAY_NAME)} />
                <Field label="Display Email Address" value={form.watch(DISPLAY_EMAIL)} />
                <Field label="Display Mobile" value={form.watch(DISPLAY_MOBILE)} />
                <Field label="Opt In Partner Online Ads" value={form.watch(ADS)} />
                <Field label="Opt In Partner Emails" value={form.watch(PARTNER_EMAIL)} />
                <Field label="Display Prop Address" value={form.watch(PROP_ADDRESS)} />
                <Field label="Opt In General" value={form.watch(OPT_GENERAL)} />
                <Field label="Display Landline" value={form.watch(DISPLAY_LANDLINE)} />
              </div>
            </Section>
            <Section title="Accounting Info.">
              <div className="grid-3">
                <Field label="Account ID" value={form.watch(ACCOUNT_ID)} />
                <Field label="Payment Type" value={form.watch(PAYMENT_TYPE)} />
                {form.watch(PAYMENT_TYPE) === "ZELLE" ? <Field label="Zelle URL" value={form.watch(ZELLE_URL)} /> : <></>}
                {form.watch(PAYMENT_TYPE) == "ACH" ? <>
                  <Field label="ACH Routing" value={form.watch(ACH_ROUTING)} />
                  <Field label="ACH Account" value={form.watch(ACH_ACCOUNT)} />
                  <Field label="ACH Account Name" value={form.watch(ACH_ACCOUNT_NAME)} />
                  <Field label="ACH Bank Name" value={form.watch(ACH_BANK_NAME)} />
                </> : <></>}
              </div>

              <h3 className="sub-heading">E-Account Info.</h3>
              <div className="grid-3">
                <Field label="E Account #" value={form.watch(E_ACCOUNT_NO)} />
                <Field label="E Account Name" value={form.watch(E_ACCOUNT_NAME)} />
                <Field label="E Account Email" value={form.watch(E_ACCOUNT_EMAIL)} />
                <Field label="E Account Phone" value={form.watch(E_ACCOUNT_PHONE)} />
              </div>

              <h3 className="sub-heading">Accounting Preferences</h3>
              <div className="grid-2">
                <Field label="E-Com Signup" value={form.watch(E_COM_SIGNUP)} />
                {form.watch(E_COM_SIGNUP) ? <Field label="E-Com Start Date" value={form.watch(E_COM_START_DATE) ? moment(form.watch(E_COM_START_DATE)).format('MMM DD, YYYY') : ''} /> : <></>}
                <Field label="Auto Billing Enrolled" value={form.watch(AUTO_BILLING_ENROLL)} />
                {form.watch(AUTO_BILLING_ENROLL) ? <Field label="E-Com Start Date" value={form.watch(AUTO_BILLING_START_DATE) ? moment(form.watch(AUTO_BILLING_START_DATE)).format('MMM DD, YYYY') : ''} /> : <></>}
                <Field label="Auto Billing For Lease Admin" value={form.watch(AUTO_BILLING_LA)} />
                {form.watch(AUTO_BILLING_LA) ? 
                  <>
                    <Field label="Start Date" value={form.watch(AUTO_BILLING_LA_START_DATE) ? moment(form.watch(AUTO_BILLING_LA_START_DATE)).format('MMM DD, YYYY') : ''} />
                    <Field label="Start Date" value={form.watch(AUTO_BILLING_LA_END_DATE) ? moment(form.watch(AUTO_BILLING_LA_END_DATE)).format('MMM DD, YYYY') : ''} />
                  </> : <></>}
              </div>
            </Section>
          </div>
        }
      </div>
    </>
  );
};

export default DownloadProfile;